import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { MVTLayer } from "deck.gl";
import { Feature, Geometry } from "geojson";
import { useJunctionTileUrl, JunctionTileSource } from "@/hooks/layers/useJunctionTileUrl";
import { DebounceTimeMilliseconds, MaxConcurrentRequests } from "@/hooks/layers/useTrajectoriesLayer";
import { hexToRgb } from "@/utils/colourUtils";
import { junctionColors, system } from "@/styles/theme";
interface GateFeatureProperties {
  label: string;
  junctionId: number;
}
export function useJunctionGatesLayer(junctionId, visible) {
  const $ = _c(5);
  let t0;
  if ($[0] !== junctionId) {
    t0 = {
      junctionId
    };
    $[0] = junctionId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const tileUrl = useJunctionTileUrl(JunctionTileSource.gates, t0);
  const t1 = visible ? tileUrl : null;
  let t2;
  if ($[2] !== t1 || $[3] !== visible) {
    t2 = new MVTLayer({
      id: "junction-gates",
      visible,
      data: t1,
      debounceTime: DebounceTimeMilliseconds,
      maxRequests: MaxConcurrentRequests,
      minZoom: 0,
      maxZoom: 16,
      getLineColor: hexToRgb(junctionColors.gate),
      getLineWidth: 6,
      pointType: "text" as const,
      getText: _temp,
      getTextColor: hexToRgb(junctionColors.gateLabel),
      getTextSize: 2,
      textSizeUnits: "meters" as const,
      textFontFamily: system.token("fonts.body")
    });
    $[2] = t1;
    $[3] = visible;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp(f) {
  return f.properties.label;
}